import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { decodeToken } from '../../utils';
import { getCommonInfo, postMAKAB020 } from '../../services/Api';
const PopupSendMail = ({ closePopup, receiver }) => {
    const token = useSelector(({ auth }) => auth.login.token);
    const login = useSelector(({ auth }) => auth.login);
    const decode = decodeToken(token);

    const [mailData, setMailData] = useState({
        title: '',
        content: '',
    });
    const [commonInfo, setCommonInfo] = useState(null);

    useEffect(() => {
        getCommonInfo().then(({ data }) => {
            setCommonInfo(data);
        });
    }, []);

    const handleChange = (e) => {
        setMailData({
            ...mailData,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = () => {
        if (mailData.content.trim() === '') {
            window.alert('모든 정보를 입력해 주세요.');
            return;
        }
        const payload = {
            toMemberId: receiver?.id,
            readed: 'N',
            title: mailData.title,
            contents: mailData.content,
            tblName: 'propose',
            revDel: 'N',
            sendDel: 'N',
        };

        postMAKAB020(payload)
            .then(() => {
                window.alert('쪽지가 성공적으로 전송되었습니다.');
                closePopup();
            })
            .catch((error) => {
                window.alert('쪽지 전송에 실패하였습니다.');
                console.log(error);
            });
    };

    return (
        <div className={`sendPop active`} id="sendPop">
            <div className="sendPop__container">
                <button id="sendPopClose" type="button" className="sendPop__close" onClick={closePopup} />
                <h2 className="sendPop__tit">My 쪽지</h2>
                <p className="sendPop__desc">덴탈잡은 항상 더 좋은 서비스를 제공하기 위해서 최선을 다하겠습니다.</p>
                <table className="sendPop__table">
                    <tbody>
                        <tr>
                            <th>보내는 사람</th>
                            <td>
                                <input
                                    type="text"
                                    className="sendPop__input"
                                    name="sender"
                                    value={
                                        decode?.authorities === 'ROLE_P'
                                            ? commonInfo?.nameKor || ''
                                            : decode?.authorities === 'ROLE_C'
                                                ? commonInfo?.bizCompany || ''
                                                : ''
                                    }
                                    readOnly
                                    style={{ backgroundColor: '#eee' }}
                                />
                            </td>

                        </tr>
                        <tr>
                            <th>받는 사람</th>
                            <td>
                                <input
                                    type="text"
                                    className="sendPop__input"
                                    name="receiver"
                                    value={receiver?.name || ''}
                                    readOnly
                                    style={{ backgroundColor: '#eee' }}
                                />
                            </td>
                        </tr>
                        {/* <tr>
                            <th>
                                제목<span>*</span>
                            </th>
                            <td>
                                <input
                                    type="text"
                                    className="sendPop__input"
                                    name="title"
                                    value={mailData.title}
                                    onChange={handleChange}
                                    required
                                />
                            </td>
                        </tr> */}
                        <tr>
                            <th>
                                내용<span>*</span>
                            </th>
                            <td>
                                <textarea
                                    name="content"
                                    className="sendPop__textarea"
                                    value={mailData.content}
                                    onChange={handleChange}
                                    required
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div className="sendPop__btbx">
                    <button type="button" className="sendPop__btn" onClick={handleSubmit}>
                        쪽지 보내기
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PopupSendMail;
